import { UnderlineTabs } from "../../components/ui/UnderlineTabs.jsx";
import { ACCOUNT_DETAIL_TABS } from "./accountDetailTabs.js";

export function AccountDetailTabs({ activeTab, onChange }) {
  return (
    <UnderlineTabs
      tabs={ACCOUNT_DETAIL_TABS}
      activeTab={activeTab}
      onChange={onChange}
      paddingX={14}
    />
  );
}
